import { Component, HostListener, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MockAPIProvider } from 'src/app/shared/services/mock-api.provider';

import { AccordionTab } from 'ascedia-design-system/lib/models/accordion-tab.interface';
import { Breakpoint } from 'ascedia-design-system/lib/models/breakpoint.enum';
import { Window } from 'ascedia-design-system/lib/models/window.interface';


@Component({
	selector: 'app-safety',
	templateUrl: './safety.component.html'
})
export class SafetyComponent implements OnInit {

	public tabListSafety$: Observable<AccordionTab[]>;

	public window: Window = { width: 0, height: 0};
	public isMobile: boolean = false;
	public toResize: any;
	public toResizeMs: number = 200;

	constructor(
		private _mockAPIProvider: MockAPIProvider,
	) { }

	ngOnInit(): void {
		this.tabListSafety$ = this._mockAPIProvider.load('main/component-safety.json', false)
			.pipe(map((res: AccordionTab[]) => {
				if(res && res.length > 0) {
					//console.log('component-safety:', res);
					return res;
				}
				return null;
			}));
	}

	/**
	 * Listen for window resize
	 * @param event 
	 */
	 @HostListener('window:resize', ['$event'])
	 onResize(event:any) {
		 //console.log('Resize', event.target.innerWidth, 'x', event.target.innerHeight);
		 clearTimeout(this.toResize);
		 this.toResize = setTimeout(()=>{
			 this.getWindowDims();
		 }, this.toResizeMs);
	 }
 
 
	/**
	 * Get window dimensions
	 * @param event 
	*/
	public getWindowDims(event:any = null) {
		if(event) {
			this.window.width = event.target.innerWidth;
			this.window.height = event.target.innerHeight;
		} else {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		}
		//console.log('window:', this.window);
		if(this.window.width < Breakpoint.lg) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}

	}

}
